const tasksXlsxExportModule = {
  namespaced: true,

  state: () => ({
    startDate: ''
  }),

  getters: {
    getStartDate (state) {
      return state.startDate
    }
  },

  mutations: {
    setStartDate (state, startDate) {
      state.startDate = startDate
    }
  }
}

export default tasksXlsxExportModule
